import { c as _c } from "react/compiler-runtime";
import { Tooltip } from "react-tooltip";
import { formatNumberWithCommasOrDash } from "@/helpers/Helpers";
export default function UserPageStatsActivityWalletTableRowGas(t0) {
  const $ = _c(25);
  const {
    gas,
    gasGwei,
    gasPriceGwei
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div aria-label="Gas Information" className="tw-h-10 tw-w-10 tw-flex tw-justify-center tw-items-center tw-rounded-full focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400" data-tooltip-id="gas-information"><svg aria-hidden="true" className="tw-flex-shrink-0 tw-w-6 tw-h-6 sm:tw-w-5 sm:tw-h-5 tw-text-iron-300" x="0px" y="0px" viewBox="0 0 494.06 494.06" width="512" height="512"><g><path fill="currentColor" d="M259.18,58.7H106.39c-8.29,0-15,6.71-15,15v105.86c0,8.28,6.71,15,15,15h152.79c8.28,0,15-6.72,15-15V73.7   C274.18,65.41,267.46,58.7,259.18,58.7z M244.18,164.56H121.39V88.7h122.79V164.56z" /><path fill="currentColor" d="M471.96,85.81l-0.005-0.002l-64.033-60.604c-6.017-5.694-15.51-5.433-21.205,0.584c-5.694,6.017-5.434,15.51,0.584,21.205   l33.228,31.449c-20.81,7.71-35.689,27.77-35.689,51.229c0,24.41,16.11,45.14,38.25,52.1v185.58c0,4.97-4.05,9.01-9.01,9.01   c-4.97,0-9.01-4.04-9.01-9.01v-94.3c0-24.8-20.19-44.99-44.99-44.99h-34.79V50.05c0-24.82-20.18-45-45-45H85.27   c-24.81,0-45,20.18-45,45v333.78h-5.19C15.73,383.83,0,399.57,0,418.92v55.09c0,8.29,6.71,15,15,15h335.57c8.28,0,15-6.71,15-15   v-55.09c0-19.35-15.74-35.09-35.09-35.09h-5.19V258.06h34.79c8.26,0,14.99,6.73,14.99,14.99v94.3c0,21.51,17.5,39.01,39.01,39.01   s39.01-17.5,39.01-39.01V182.56c23.53-6.08,40.97-27.49,40.97-52.89C494.06,111.73,485.36,95.78,471.96,85.81z M295.29,383.83   H70.27V50.05c0-8.27,6.73-15,15-15h195.02c8.28,0,15,6.73,15,15C295.29,55.79,295.29,378.771,295.29,383.83z M335.57,418.92v40.09   H30v-40.09c0-2.81,2.28-5.09,5.08-5.09c11.613,0,281.437,0,295.4,0C333.29,413.83,335.57,416.11,335.57,418.92z M439.45,154.28   c-13.54,0-24.61-11.023-24.61-24.61c0-13.57,11.04-24.61,24.61-24.61s24.61,11.04,24.61,24.61   C464.06,143.247,453.011,154.28,439.45,154.28z" /></g></svg></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div> Gas:</div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== gas) {
    t4 = gas.toFixed(5);
    $[3] = gas;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = +t4;
  let t6;
  if ($[5] !== t5) {
    t6 = formatNumberWithCommasOrDash(t5);
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t6) {
    t7 = <div className="tw-inline-flex tw-justify-between tw-space-x-2">{t3}{" "}<div>{t6}</div></div>;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div>GWEI:</div>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== gasGwei) {
    t9 = formatNumberWithCommasOrDash(gasGwei);
    $[10] = gasGwei;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t9) {
    t10 = <div className="tw-inline-flex tw-justify-between tw-space-x-2">{t8} <div> {t9}</div></div>;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div>Gas Price:</div>;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== gasPriceGwei) {
    t12 = gasPriceGwei.toFixed(2);
    $[15] = gasPriceGwei;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  const t13 = +t12;
  let t14;
  if ($[17] !== t13) {
    t14 = formatNumberWithCommasOrDash(t13);
    $[17] = t13;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== t14) {
    t15 = <div className="tw-inline-flex tw-justify-between tw-space-x-2">{t11}<div>{t14}</div></div>;
    $[19] = t14;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== t10 || $[22] !== t15 || $[23] !== t7) {
    t16 = <>{t1}<Tooltip id="gas-information" style={t2}><div className="tw-flex tw-flex-col">{t7}{t10}{t15}</div></Tooltip></>;
    $[21] = t10;
    $[22] = t15;
    $[23] = t7;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  return t16;
}